<ion-footer class="footer-bg bet-slip-trigger">
    <div class="bet-slip-trigger">
      <div  class="trigger" (click)="openBetSlipModal()" >
        <span style="margin-right: 20px;" *ngIf="is_logged" class="blanceBlock">{{'COMPONENTS.SLIDEMENU.BALANCE-CURRENCY' | translate}} {{userInfo.balance | number: '2.'}}</span>
        <div *ngIf="item > 0" class="number">{{item}}</div><span class="icon icon-bet-slip"></span> {{ 'COMPONENTS.FOOTER.BUTTONS.BET_SLIP' | translate }}
      </div>
      
    </div>

</ion-footer>